import React from 'react'

import InlineCta, { InlineCtaProps } from '~/components/InlineCta'
import RoundedCta, { RoundedCtaProps } from '~/components/RoundedCta'

import { track } from '~/utils/analytics'

import { AnalyticEvent } from '~/data/serialize-analytics'

export type CtaProps =
  | (InlineCtaProps & { ctaType: 'inline'; analyticEvent?: AnalyticEvent })
  | (RoundedCtaProps & { ctaType: 'rounded'; analyticEvent?: AnalyticEvent })

/**
 * Cta from type `rouded or inline`
 * @param props
 * @returns RoundedCta | InlineCta
 */
function Cta(props: CtaProps) {
  const handleClick = (e) => {
    props?.analyticEvent?.label && track(props.analyticEvent?.label, {})

    props?.onClick && props.onClick(e)
  }

  const { analyticEvent, ...rest } = props
  return props.ctaType === 'rounded' ? (
    <RoundedCta {...(rest as RoundedCtaProps)} onClick={handleClick} />
  ) : (
    <InlineCta
      {...(rest as InlineCtaProps)}
      icon={true}
      onClick={handleClick}
    />
  )
}

export default Cta
